<div class="backIcon">
    <mat-icon class="close-icon" [routerLink]="['/private-space/view-sporsorship-requests']"
      >close</mat-icon
    >
  </div>
  
  <div class="text-center mat-header">Edit a Sponsorship Request</div>
  <div class="form-group col-sm-12 text-center" *ngIf="isLoading">
    <img
      class="loader"
      src="../../assets/images/loader.gif"
      width="60px"
      alt=""
    />
  </div>
  <mat-card-content *ngIf="!isLoading">
            <form [formGroup]="editSponsorshipForm" (ngSubmit)="onSubmitEditForm()"
            class="row g-3 needs-validation">
            <div class="form-group col-sm-12">
              <label  for="sponsorshipName">Sponsorship Name</label>
              <input class="form-control" id="sponsorshipName" formControlName="name" required type="text" value="" />
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.name.touched) &&
                editSponsorshipForm.controls.name.errors?.required
              "
              >Please fill</span
            >
            </div>
          
            <div class="form-group col-sm-12">
              <label  for="searchProperty">Property</label>

              <input class="form-control" (keyup)="onSearchProperties($event)"  id="searchProperty" placeholder="Search Property" formControlName="propertyName" type="text" value="" />
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.propertyName.touched) &&
                editSponsorshipForm.controls.propertyName.errors?.required
              "
              >Please fill</span
            >
              <div *ngIf="propertiesResults" class="search-results">
                <div *ngIf="propertiesSearchResults.length == 0 && !displaySelectedProperty"> <!-- TODO -->
                  <!-- <c-alert class="noMargins" color="warning">No results found for your property search!</c-alert> -->
                </div>
          
                <table *ngIf="propertiesSearchResults.length"  class="table table-striped table-hover table-bordered" small>
                  <thead>
                    <tr>
                      <th><small><b>Name</b></small></th>
                      <th><small><b>Category</b></small></th>
                      <th><small><b>Status</b></small></th>
                      <th><small><b>No. of days</b></small></th>
                      <th><small><b>Industry</b></small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr (click)="onSelectProperty(property._source, property._id)" class="results-list"
                      *ngFor="let property of propertiesSearchResults">
                      <td>{{property._source.name}}</td>
                      <td>{{property._source.category}}</td>
                      <td>{{property._source.status}}</td>
                      <td>{{property._source.noOfDays}}</td>
                      <td>{{property._source.industry}}</td>
                    </tr>
                  </tbody>
                </table>
          
                <div class="card" *ngIf="displaySelectedProperty">
                  <div class="card-body" class="noPadding">
          
                    <table class="table table-striped table-hover table-bordered">
                      <thead>
                        <tr>
                          <th><small><b>Name</b></small></th>
                          <th><small><b>Category</b></small></th>
                          <th><small><b>Industry</b></small></th>
                          <th><small><b>Status</b></small></th>
                          <th><small><b></b></small></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>{{selectedProperty.name}}</th>
                          <td>{{selectedProperty.category}}</td>
                          <td>{{selectedProperty.industry}}</td>
                          <td>{{selectedProperty.status}}</td>
                          <td style="width: 10px;">
                            <mat-icon style="font-size: 17px;" (click)="removeProperty()"
                            type="button"
                            class="icon-button">delete</mat-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
          
                  </div>
                </div>
          
              </div>
          
              <!-- <div class="text-center">
                <c-spinner *ngIf="isSearchingProperties" class="spinner" color="dark" variant="grow"></c-spinner>
              </div> -->
            </div>
          
            <div class="form-group col-sm-12">
              <label  for="searchSponsor">Sponsor</label>
              <input class="form-control" (keyup)="onSearchSponsors($event)" type="text"  formControlName="sponsorName"
              placeholder="Search Sponsor" >
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.sponsorName.touched) &&
                editSponsorshipForm.controls.sponsorName.errors?.required
              "
              >Please fill</span
            >
              <p *ngIf="sponsorValid" class="invalid-feedback">Please search and select a Sponsor</p>
              <div *ngIf="sponsorsResults" class="search-results">
                <div *ngIf="sponsorsSearchResults.length == 0 && !displaySelectedSponsor"> <!-- TODO -->
                  <!-- <c-alert class="noMargins" color="warning">No results found for your sponsors search!</c-alert> -->
                </div>
          
                <table *ngIf="sponsorsSearchResults.length"  class="table table-striped table-hover table-bordered" small>
                  <thead cTableColor="light">
                    <tr>
                      <th><small><b>Logo</b></small></th>
                      <th><small><b>Name</b></small></th>
                      <th><small><b>type</b></small></th>
                      <th><small><b>Category</b></small></th>
                      <th><small><b>Country</b></small></th>
                      <th><small><b>Industry</b></small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr (click)="onSelectSponsor(sponsor._source, sponsor._id)" class="results-list"
                      *ngFor="let sponsor of sponsorsSearchResults">
          
                      <td class="text-center">
                        <img height="30" width="30" src="../../../assets/images/default-logo.png" />
                      </td>
                      <td>{{sponsor._source.name}}</td>
                      <td>{{sponsor._source.type}}</td>
                      <td>{{sponsor._source.category}}</td>
                      <td>{{sponsor._source.country}}</td>
                      <td>{{sponsor._source.industry}}</td>
                    </tr>
                  </tbody>
                </table>
          
                <div class="card" *ngIf="displaySelectedSponsor">
                  <div class="card-body noPadding">
          
                    <table class="table table-striped table-hover table-bordered">
                      <thead>
                        <tr>
                          <th><small><b>Logo</b></small></th>
                          <th><small><b>Name</b></small></th>
                          <th><small><b>type</b></small></th>
                          <th><small><b>Category</b></small></th>
                          <th><small><b>Country</b></small></th>
                          <th><small><b>Industry</b></small></th>
                          <th><small><b></b></small></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">
                            <img height="30" width="30" src="../../../assets/images/default-logo.png" />
                          </td>
                          <th>{{selectedSponsor.name}}</th>
                          <td>{{selectedSponsor.type}}</td>
                          <td>{{selectedSponsor.category}}</td>
                          <td>{{selectedSponsor.country}}</td>
                          <td>{{selectedSponsor.industry}}</td>
                          <td style="width: 10px;">
                            <mat-icon style="font-size: 17px;" (click)="removeSponsor()"
                            type="button"
                            class="icon-button">delete</mat-icon>
                          </td>
                        </tr>
          
                      </tbody>
                    </table>
          
                  </div>
                </div>
              </div>
          
              <div class="text-center">
                <!-- <c-spinner *ngIf="isSearchingSponsors" class="spinner" color="dark" variant="grow"></c-spinner> -->
              </div>
            </div>
          
            <div class="form-group col-sm-6">
              <label  for="sponsorshipValue">Value</label>
              <input class="form-control" id="sponsorshipValue" formControlName="value" required type="text" value="" />
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.value.touched) &&
                editSponsorshipForm.controls.value.errors?.required
              "
              >Please fill</span
            >
            </div>
            <div class="form-group col-sm-6">
              <label  for="sponsorshipType">Sponsorship Type</label>
              <input class="form-control" id="sponsorshipType" formControlName="type" required type="text" value="" />
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.type.touched) &&
                editSponsorshipForm.controls.type.errors?.required
              "
              >Please fill</span
            >
            </div>
          
            <div class="form-group col-sm-6">
              <label  for="sponsorshipStatus">Status</label>
              <!-- <select class="form-control" id="sponsorshipStatus" formControlName="status" required>
                <option value="">Choose...</option>
                <option>NEW</option>
                <option>ACTIVE</option>
                <option>INACTIVE</option>
              </select> -->
              <input class="form-control" id="status" formControlName="status" type="text" readonly />
            </div>
            <!-- <div class="form-group col-sm-6">
              <label  for="submissionDate">Submission date</label>
              <input class="form-control" type="date" id="submissionDate" name="submissionDate" formControlName="submissionDate" required>
              <span
              class="validation-error"
              *ngIf="
                (customStylesValidated || editSponsorshipForm.controls.submissionDate.touched) &&
                editSponsorshipForm.controls.submissionDate.errors?.required
              "
              >Please fill</span
            >
            </div>  -->
            <div class="form-group col-sm-12 text-center" *ngIf="loading">
              <img
                class="loader"
                src="../../assets/images/loader.gif"
                width="60px"
                alt=""
              />
            </div>
            <div class="form-group col-sm-12">
              <!-- <button class="me-1" color="success" type="submit">
                Submit form
              </button>
              <button (click)="onReset()" cButton color="secondary" type="reset">
                Reset
              </button> -->
              <button
              style="background-color: rgba(74, 116, 54, 255); color: #fff"
              class="btn btn-success"
              type="submit"
            >
              Submit form
            </button>
            <button
              style="background-color: black; color: #fff"
              class="btn"
              type="reset"
            >
              Reset
            </button>
              <div class="text-center">
                <!-- <c-spinner *ngIf="isLoading" class="spinner" color="dark" variant="grow"></c-spinner> -->
              </div>
            </div>
          
          </form>
  </mat-card-content>